import React, { Component, createRef, useRef } from "react";
import { connect } from "react-redux";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import {
  Islogin,
  Logout,
  inviteAction,
  getActiveJobMela,
  setRedirectionLink,
  getMenudata,
  getActiveHeadings,
  getSocialMedia,
  getUserNotifications,
  markAsReadNotification,
  clearAllUserNotifications,
  // get_User_Type, get_User_District, get_genders
} from "../../actions/accountAction";
import { UnsetNotification } from "../../actions/notificationAction";
import store from "../../store";
import LanguageSelector from "./LanguageSelector";
import Loader from "react-loader-spinner";
import { translate } from "react-multi-lang";
import "react-notifications/lib/notifications.css";
import FontSizeChanger from "react-font-size-changer";
import { Link } from "react-router";
import { chunk } from "../../helpers";
import ServerSetting from "../../config.json";


const INVITES_TO_SHOW = 5;

class Header extends Component {
  constructor(props) {
    super(props);
    this.marqueeRef = React.createRef();
    this.state = {
      basePath: window.location.protocol + "//" + window.location.host + "/",
      isOpen: false,
      showNofication: false,
      notifications: this.formatNotifications(this.props.actionReducer.usernotifications?.notifications),
      isNotificationPaused: false,
      hoveredPlatform: null,
      showTwitterModal: false,
      lastFocusedIconId: null,
      modalOpen: false,
    };

    this.twitterRef = React.createRef();

    if (
      localStorage.getItem("Islogin") === "true" &&
      localStorage.getItem("Islogin")
    ) {
      store.dispatch(Islogin());
      store.dispatch(getUserNotifications());
    }
    this.dropdownRef = React.createRef();
    this.fraud = React.createRef();
    this.foreignLinks = React.createRef();

    store.dispatch(getActiveJobMela());
    store.dispatch(getMenudata());
    store.dispatch(getActiveHeadings());
    store.dispatch(getSocialMedia());
  }

  formatNotifications = (userNotifications) => {
    let formatted = [];
    Object.entries(userNotifications || {}).forEach(([date, notifications]) => {
      formatted.push({ date, notifications: notifications.map(n => ({ ...n, showNofication: false })) });
    });

    return formatted;
  };
  toggleNotification = (dateIndex, notificationIndex) => {
    this.setState((prevState) => {

      const updatedNotifications = [...prevState.notifications]; // Copy array
      updatedNotifications[dateIndex] = { ...updatedNotifications[dateIndex] }; // Copy date object
      updatedNotifications[dateIndex].notifications = [...updatedNotifications[dateIndex].notifications]; // Copy notifications array

      updatedNotifications[dateIndex].notifications[notificationIndex] = {
        ...updatedNotifications[dateIndex].notifications[notificationIndex],
        showNofication: !updatedNotifications[dateIndex].notifications[notificationIndex].showNofication
      }; // Toggle value
      if (this.state.notifications[dateIndex].notifications[notificationIndex].is_read === "0") {

        store.dispatch(markAsReadNotification(updatedNotifications[dateIndex].notifications[notificationIndex].id))
        updatedNotifications[dateIndex].notifications[notificationIndex].is_read = "1"

        this.props.actionReducer.usernotifications.unread_count = parseInt(this.props.actionReducer.usernotifications.unread_count) - 1
      }
      return { notifications: updatedNotifications };
    });
  };


  redirectToJobs = () => {
    document.getElementById("jobMelaModal").click();
    this.props.router.push("/job-placement-fair-employers");
  };

  redirectToJobsCloseRegisterModal = () => {
    document.getElementById("registerModal").click();
    this.props.router.push("/job-placement-fair-employers");
  };

  closeModal = () => {
    document.getElementById("registerModal").click();
  };

  openDropdown = (menuId) => {
    const dropdown = document.getElementById(`dropdown-${menuId}`);
    if (dropdown) {
      dropdown.setAttribute("aria-expanded", "true");
      dropdown.classList.add("show");
      dropdown.nextElementSibling?.classList.add("show");
    }
  };

  closeDropdown = (menuId) => {
    const dropdown = document.getElementById(`dropdown-${menuId}`);
    if (dropdown) {
      dropdown.setAttribute("aria-expanded", "false");
      dropdown.classList.remove("show");
      dropdown.nextElementSibling?.classList.remove("show");
    }
  };

  handleDropdownBlur = (event, menuId) => {
    setTimeout(() => {
      const dropdownButton = document.getElementById(`dropdown-${menuId}`);

      // If dropdown exists (i.e. it's a dropdown item)
      if (dropdownButton) {
        const dropdownElement = dropdownButton.parentElement;

        // If no focused element inside this dropdown, close it
        if (!dropdownElement.contains(document.activeElement)) {
          this.closeDropdown(menuId);
        }
      }
    }, 0);
  };







  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.notificationReducer &&
      nextProps.notificationReducer.Notification.hasOwnProperty("type")
    ) {
      switch (nextProps.notificationReducer.Notification.type) {
        case "info":
          NotificationManager.info("Info message");
          break;
        case "success":
          NotificationManager.success(
            nextProps.notificationReducer.Notification.message,
            "",
            4000
          );
          break;
        case "warning":
          NotificationManager.warning(
            nextProps.notificationReducer.Notification.message,
            "",
            9000
          );
          break;
        case "error":
          NotificationManager.error(
            nextProps.notificationReducer.Notification.message,
            "",
            9000
          );
          break;
        default:
          return;
      }
      store.dispatch(UnsetNotification());
    }
  }

  inviteAction = (val, job) => {
    store.dispatch(inviteAction({ status: val, request_from: job.user_id }));
  };



  checkUserType = () => {
    const userType = ["7", "6", "10", "12"];
    const filterindex = userType.findIndex(
      (user) => user === this.props.actionReducer.Loginuser.user_type
    );
    return filterindex !== -1 ? true : false;
  };

  logout() {
    store.dispatch(Logout());
  }

  clickedJobMela = () => {
    if (
      localStorage.getItem("Islogin") &&
      localStorage.getItem("Islogin") === "true"
    ) {
      this.props.router.push("jobfair");
    }
  };

  changeLanguage = (event) => {
    window.location.href = this.state.basePath + "signup?type=" + event;
  };

  clickedJobMela = () => {
    // if (localStorage.getItem('Islogin') && localStorage.getItem('Islogin') === 'true') {
    this.props.router.push("jobfair");
    // }
  };

  getTooltip = () => {
    return "To see the available vacancies, Click here";
    // const allMelas = this.props.actionReducer.allMelas
    // if (allMelas && allMelas.length > 0) {
    //     return `${allMelas[0].job_mela_description}`
    // }
  };

  closeForeignModal = () => {
    document.getElementById("foreignModal").click();
    store.dispatch(setRedirectionLink(`foreign-counselling-details`));
  };

  componentDidMount() {
    document.addEventListener("click", this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {

    if (prevProps.actionReducer.usernotifications?.notifications !== this.props.actionReducer.usernotifications?.notifications) {
      this.setState({ notifications: this.formatNotifications(this.props.actionReducer.usernotifications.notifications) });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  }

  handleClickOutside = (event) => {

    if (this.dropdownRef.current && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ isOpen: false });
    }
  };
  handleStart = () => {
    if (this.fraud.current) {
      this.fraud.current.start();
    }
  };

  handleStop = () => {
    if (this.fraud.current) {
      this.fraud.current.stop();
    }
  };


  // componentDidMount() {
  //   // Facebook SDK
  //   if (!document.getElementById("facebook-jssdk")) {
  //     const script = document.createElement("script");
  //     script.id = "facebook-jssdk";
  //     script.src =
  //       "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v16.0";
  //     script.onload = () => {
  //       if (window.FB) {
  //         window.FB.XFBML.parse();
  //       }
  //     };
  //     document.body.appendChild(script);
  //   } else if (window.FB) {
  //     window.FB.XFBML.parse();
  //   }
  // }

  // componentDidMount() {
  //   // Load Facebook SDK
  //   if (!window.FB) {
  //     ((d, s, id) => {
  //       var js, fjs = d.getElementsByTagName(s)[0];
  //       if (d.getElementById(id)) { return; }
  //       js = d.createElement(s); js.id = id;
  //       js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v15.0";
  //       fjs.parentNode.insertBefore(js, fjs);
  //     })(document, 'script', 'facebook-jssdk');
  //   }

  //   if (!window.twttr) {
  //     const script = document.createElement("script");
  //     script.src = "https://platform.twitter.com/widgets.js";
  //     script.async = true;
  //     document.body.appendChild(script);
  //   }
  // }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.hoveredPlatform !== this.state.hoveredPlatform) {
      // Facebook
      if (this.state.hoveredPlatform === "facebook" && window.FB) {
        window.FB.XFBML.parse();
      }
      // Twitter
      // if (this.state.hoveredPlatform === "twitter" && window.twttr) {
      //   window.twttr.widgets.load();
      // }

      if (this.state.hoveredPlatform === "twitter" && window.twttr && window.twttr.widgets) {
        window.twttr.widgets.load(this.twitterRef.current);
      }
    }
  }

  componentDidMount() {
    // Load Twitter
    if (!window.twttr) {
      const script = document.createElement("script");
      script.src = "https://platform.twitter.com/widgets.js";
      script.async = true;
      document.body.appendChild(script);
    }
    // Load Facebook
    if (!window.FB) {
      ((d, s, id) => {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v15.0";
        fjs.parentNode.insertBefore(js, fjs);
      })(document, "script", "facebook-jssdk");
    }

    if (!window.twttr) {
      const script = document.createElement("script");
      script.src = "https://platform.twitter.com/widgets.js";
      script.async = true;
      script.onload = () => {
        if (this.state.hoveredPlatform === "twitter") {
          window.twttr.widgets.load();
        }
      };
      document.body.appendChild(script);
    }
  }

  // loadTwitterScript = () => {
  //   return new Promise((resolve) => {
  //     if (window.twttr) {
  //       resolve(window.twttr);
  //     } else {
  //       const script = document.createElement("script");
  //       script.src = "https://platform.twitter.com/widgets.js";
  //       script.async = true;
  //       script.onload = () => resolve(window.twttr);
  //       document.body.appendChild(script);
  //     }
  //   });
  // };

  renderSocialFeed = () => {
    const { hoveredPlatform, media_url } = this.state;
    { console.log(media_url, "media_url") }
    switch (hoveredPlatform) {
      case "facebook":
        return (
          <div
            className="fb-page"
            data-href="https://www.facebook.com/degsdt"
            data-tabs="timeline"
            data-width=""
            data-height="500"
            data-small-header="false"
            data-adapt-container-width="true"
            data-hide-cover="false"
            data-show-facepile="true"
          >
            <blockquote
              cite="https://www.facebook.com/degsdt"
              className="fb-xfbml-parse-ignore"
            >
              <a
                aria-label="Visit DEGSDT Facebook page"
                href="https://www.facebook.com/degsdt">DEGSDT Facebook</a>
            </blockquote>
          </div>
        );

      case "youtube":
        return (
          // <iframe
          //   width="100%"
          //   height="500"
          //   src="https://www.youtube.com/watch?v=rRasMojMx7k" // static URL
          //   title="YouTube feed"
          //   frameBorder="0"
          //   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          //   allowFullScreen
          // ></iframe>
          <iframe
            src="https://www.youtube.com/embed/rRasMojMx7k"
            frameBorder="0"
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
            }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="YouTube Video"
          />
        );

      // case "linkedin":
      //   return (
      //     <iframe
      //       src="https://www.linkedin.com/embed/feed/update/urn:li:share:STATIC_POST_ID"
      //       height="500"
      //       width="100%"
      //       frameBorder="0"
      //       allowFullScreen
      //       title="LinkedIn Feed"
      //     ></iframe>
      //   );

      case "instagram":
        return (
          <iframe
            src="https://www.instagram.com/degsdt_punjab/embed"
            height="500"
            width="100%"
            frameBorder="0"
            allowFullScreen
            title="Instagram Feed"
          ></iframe>
        );

      // case "twitter":
      //   return (
      //     <div ref={this.twitterRef}>
      //       <a
      //         className="twitter-timeline"
      //         data-width="500"
      //         data-height="500"
      //         href="https://twitter.com/DEGSDT"
      //       >
      //         Tweets by DEGSDT
      //       </a>
      //     </div>
      //   );

      default:
        return null;
    }
  };

  handleOpenModal = (media, iconId) => {
    this.setState(
      {
        media_url: media.platform_url,
        platform_name: media.platform_name,
        lastFocusedIconId: iconId,
        modalOpen: true,
      },
      () => {
        if (window.$) {
          window.$("#exampleSocialModal").modal("show");
        }

        // Focus first focusable element in modal (Proceed)
        setTimeout(() => {
          const firstFocusable = document.querySelector(
            "#exampleSocialModal .btn-success"
          );
          if (firstFocusable) firstFocusable.focus();
        }, 300);

        // Setup focus trap for modal (optional)
        setTimeout(this.setupModalFocusTrap, 400);
      }
    );
  };

  handleCloseModal = () => {
    const { lastFocusedIconId } = this.state;

    if (window.$) {
      window.$("#exampleSocialModal").modal("hide");
    }

    this.setState({ modalOpen: false }, () => {
      // restore focus to last icon
      setTimeout(() => {
        if (lastFocusedIconId) {
          const previousIcon = document.getElementById(lastFocusedIconId);
          if (previousIcon) previousIcon.focus();
        }
      }, 300);
    });
  };

  setupModalFocusTrap = () => {
    const modal = document.getElementById("exampleSocialModal");
    if (!modal) return;

    const focusableSelectors =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const focusableElements = modal.querySelectorAll(focusableSelectors);

    if (!focusableElements.length) return;

    const first = focusableElements[0];
    const last = focusableElements[focusableElements.length - 1];

    modal.addEventListener("keydown", (e) => {
      if (e.key !== "Tab") return;

      if (e.shiftKey) {
        // Shift + Tab
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        // Tab only
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  };


  render() {
    let Mainprops = this.props;
    let name = "";

    if (
      this.props.actionReducer?.Loginuser &&
      this.props.actionReducer?.Loginuser?.displayName
    ) {
      name = this.props.actionReducer.Loginuser.displayName;
    }

    let chatInvites = [];
    if (Mainprops.actionReducer?.chatInvites) {
      chatInvites = chunk(Mainprops.actionReducer.chatInvites, INVITES_TO_SHOW);
      chatInvites = chatInvites.length ? chatInvites[0] : [];
    }

    const SERVER_PATH = ServerSetting[process.env.NODE_ENV].SERVER_PATH;

    return (
      <section className="top-header">
        {Mainprops.loaderReducer?.loader && (
          <div
            style={{
              position: "fixed",
              width: "100%",
              height: "100%",
              background: "#fdfdfd",
              opacity: 0.5,
            }}
          ></div>
        )}
        {Mainprops.loaderReducer?.loader && (
          <Loader
            style={{ position: "fixed", top: "49%", left: "48%" }}
            type="Rings"
            color="#F1911C"
            height={100}
            width={100}
          />
        )}
        <div id="foreignModal" className="modal fade">
          <div className="modal-dialog" style={{ maxWidth: "969px" }}>
            <div className="modal-content d-block">
              <div className="modal-body pt-2  pb-1 text-center">
                <div className="d-flex align-items-center w-100 justify-content-center">
                  <img
                    alt="logo"
                    src="/images/logo-1.svg"
                    className="img-fluid pb-2 home-top-logo"
                  />
                </div>

                <h5 className="mx-auto  text-uppercase mb-3">
                  {this.props.t("jobMela.pgrkam", { param: "react" })}
                </h5>
                <div className="row d-flex">
                  <div className="col-md-6 col-lg-6 col-sm-6 mb-3 d-flex">
                    <div className="first-click">
                      <img
                        alt="Login icon for registered users"
                        src="/images/mod2.png"
                        className="img-fluid pb-2 w-25"
                      />
                      <p>
                        {" "}
                        {this.props.t("homeContent.inst1", { param: "react" })}
                      </p>
                      <Link
                        to="/signin"
                        className="btn btn-danger pt-1 pb-1"
                        onClick={this.closeForeignModal}
                      >
                        {this.props.t("homeContent.clickToLogin", {
                          param: "react",
                        })}
                      </Link>
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6 col-sm-6 mb-3 d-flex">
                    <div className="first-click">
                      <img

                        alt="Registration icon for new users"
                        className="img-fluid pb-2 w-25"
                      />
                      <p className={"pl-2 pr-2"}>
                        {" "}
                        {this.props.t("homeContent.inst2", { param: "react" })}
                      </p>
                      <Link
                        to="/signup?type=1&for_coun_register=1"
                        className="btn btn-danger pt-1 pb-1"
                        onClick={this.closeForeignModal}
                      >
                        {this.props.t("homeContent.clickToRegister", {
                          param: "react",
                        })}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row m-0 M_alignCenter">
            <div className="col-md-6 col-sm-6 col-lg-6 col-6 col-xl-6 top-icon joint jhhkkj">
              <ul className="d-flex mb-0 alignbas mainuderlist">
                <LanguageSelector />

                <li className="list-inline-item">
                  <FontSizeChanger
                    targets={["#root #rootContent"]}
                    options={{
                      stepSize: 1,
                      range: 3,
                    }}
                    customButtons={{
                      up: (
                        <span style={{ fontSize: "18px", marginRight: "10px" }}>
                          A+
                        </span>
                      ),
                      down: <span style={{ fontSize: "15px" }}>A-</span>,
                      style: {
                        color: "#000",
                        width: "auto",
                        border: "none",
                      },
                    }}
                  />
                </li>
                <li className="list-inline-item uhygv">
                  {" "}
                  <Link to="/faq">
                    {this.props.t("faq", { param: "react" })}
                  </Link>
                </li>
                {/* <li className="list-inline-item "> <span>Fields with <span style={{ fontWeight:"bold"}}>*</span> marked are mandatory</span></li> */}
              </ul>
            </div>

            <div className="col-md-6 col-sm-6 col-lg-6 col-6 col-xl-6 top-icon joint jhiukjh">

              {localStorage.getItem("Islogin") &&
                localStorage.getItem("Islogin") === "true" && (
                  <ul className="d-flex mb-0 justify-content-end w-100 mainuderlist">
                    {Mainprops.route.pathname !== "/" && (
                      <li className="list-inline-item">
                        {" "}
                        <Link to="/" aria-label="Home">
                          {" "}
                          <i
                            className="fa fa-home homeiconclass"
                            aria-hidden="true"
                          ></i>
                          {/* <span class="sr-only">Home</span> */}
                        </Link>
                      </li>
                    )}
                    <li className="list-inline-item">
                      <Link to="/user-manual">
                        {this.props.t("homeContent.userManual", {
                          param: "react",
                        })}
                      </Link>
                    </li>



                    {this.checkUserType() ? (
                      <li className="list-inline-item positioncalss">
                        {Mainprops.actionReducer.chatInvites &&
                          Mainprops.actionReducer.chatInvites.length ? (
                          <span className="notification-count chatcl">
                            {Mainprops.actionReducer.chatInvites.length}
                          </span>
                        ) : null}
                        <i
                          className="fa fa-commenting-o  pull-left mt-3 dropdown-toggle Content-none chatclass"
                          id="dropdownMenuLink1"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        ></i>

                        <div
                          className={
                            Mainprops.actionReducer.chatInvites &&
                              Mainprops.actionReducer.chatInvites.length
                              ? "dropdown-menu drop-menus"
                              : "drop-menus"
                          }
                          style={{ minWidth: "18rem" }}
                          aria-labelledby="dropdownMenuLink1"
                          x-placement="bottom-start"
                        >
                          {chatInvites && chatInvites.length
                            ? chatInvites.map((invite, key) => {
                              return (
                                <div className="noti-scr">
                                  <div className="notification-box" key={key}>
                                    <div className="noti-img">
                                      <img
                                        alt="asd"
                                        className="profile-img-small"
                                        src="/images/icon2.png"
                                      />
                                    </div>
                                    <div className="noti-grid">
                                      <div className="not-title">
                                        <b>Request For Discussion</b>
                                        <span className="pl-1 d-block">
                                          {invite.name}
                                        </span>
                                      </div>
                                      <div className="noti-btn">
                                        <button
                                          aria-label={`Accept chat invite from ${invite.name}`}
                                          type="button"
                                          className="btn btn-primary btn-primary2"
                                          onClick={() =>
                                            this.inviteAction(1, invite)
                                          }
                                        >
                                          Accept
                                        </button>
                                        <button
                                          aria-label={`Decline chat invite from ${invite.name}`}
                                          type="button"
                                          onClick={() =>
                                            this.inviteAction(0, invite)
                                          }
                                          className="btn btn-primary btn-primary2 ml-2"
                                        >
                                          Decline
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })
                            : null}
                          {Mainprops.actionReducer.chatInvites &&
                            Mainprops.actionReducer.chatInvites.length >
                            INVITES_TO_SHOW ? (
                            <div className="row p-2">
                              <div className="col-md-12 text-center">
                                <Link className="date-clr" to="/invites">
                                  {this.props.t("homeContent.viewMore", {
                                    param: "react",
                                  })}
                                </Link>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </li>
                    ) : null}

                    <li className="list-inline-item show notIconMobileView" ref={this.dropdownRef} >
                      {/* {Mainprops.actionReducer.usernotifications &&
                        parseInt(Mainprops.actionReducer.usernotifications.unread_count) > 0 ? (
                        <span className="notification-count">
                          {Mainprops.actionReducer.usernotifications.unread_count}
                        </span>
                      ) : null} */}
                      <i
                        className="fa fa-bell pull-left m-0  notification_icon notificlass"
                        id="dropdownMenuButton" aria-haspopup="true" aria-expanded="false"
                        onClick={() => this.setState((prevState) => ({ isOpen: !prevState.isOpen }))}
                      ></i>
                      <div className={`dropdown-menu newdropdown-menu ${this.state.isOpen ? "show" : ""}`} onClick={(e) => e.stopPropagation()} >
                        <div className="d-flex justify-content-between p-2 align-items-baseline">
                          <p className="notificationHead">Notification</p>
                          <i className="fa fa-close notificationClose"

                            onClick={() => {
                              this.setState({ isOpen: false });
                            }}></i>
                        </div>
                        <div className="dividerLine"></div>

                        <div className="notificationPadding">
                          <div className="d-flex justify-content-end">

                            {this.state.notifications.length > 0 ? <button
                              aria-label='Clear all notifications'
                              type="button"
                              onClick={() => {
                                store.dispatch(clearAllUserNotifications());

                              }} disabled={this.state.notifications.length === 0} className="clearAllA">Clear All</button> : <></>}
                          </div>


                          {this.state.notifications.length > 0 ? (
                            this.state.notifications.map((group, dateIndex) => (
                              <div key={group.date}>
                                <h5 className="dateBlckNotification">{group.date}</h5>
                                {group.notifications.map((notification, notificationIndex) => (
                                  <div className={`lightPinkRadius ${notification.is_read === "0" ? 'notification-unreaded' : ''}`} key={notification.id}>
                                    <div className="lightPinkRadiusInner">
                                      <i className="fa fa-bell pull-left mt-2 notification_iconOrange"></i>
                                      <div className="lightPinkInner">
                                        <div className="mainNotificationContetnt">
                                          <p className="mianNotificationTitle">{notification.notification_title}</p>
                                          <p className={`mianNotificationDesc ${notification.showNofication ? "" : "hide-noification-desc"}`}>
                                            {notification.notification_message}
                                          </p>
                                          <button
                                            aria-label={notification.showNofication ? 'Read less of notification' : 'Read more of notification'}
                                            type="button"
                                            onClick={() => this.toggleNotification(dateIndex, notificationIndex)} className="mianNotificationread">
                                            {notification.showNofication ? "Read Less" : "Read More"}
                                          </button>
                                        </div>

                                        <p className="notificationTime">{notification.created_at.split(" ")[1]} {notification.created_at.split(" ")[2]}</p>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ))
                          ) : (
                            <p className="noNotificationText">No Notification available</p>
                          )}


                        </div>
                      </div>
                    </li>

                    <li className="list-inline-item mrightmin">
                      <div className="dropdown drop-outer dropLogout">
                        {/* <Link className="drop-inner pull-left btn btn-secondary">{`${this.props.t('dashboard.welcome', { param: 'react' })} ${name},`}</Link> */}
                        <Link
                          className="drop-inner pull-left mr-1 btn btn-secondary asdqed"
                          to="/myaccount"
                        >
                          {`${this.props.t("dashboard.welcome", {
                            param: "react",
                          })} ${name?.split(" ")[0]}`}
                        </Link>
                        <i
                          className="fa fa-chevron-down dropdown-toggle Content-none dropclass"
                          id="dropdownMenuLink"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        ></i>
                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuLink"
                          x-placement="bottom-start"
                        >
                          <Link
                            className="dropdown-item"
                            to="/myaccount"
                          >
                            {`${this.props.t("sidebar.dashboard", {
                              param: "react",
                            })}`}
                          </Link>
                          <Link to="/change-password" className="dropdown-item">
                            {this.props.t("changePassword.title", {
                              param: "react",
                            })}
                          </Link>
                          <Link
                            className="dropdown-item"
                            onClick={(e) => {
                              e.preventDefault();
                              this.logout();
                            }}
                          >
                            {this.props.t("header.sign_out", {
                              param: "react",
                            })}
                          </Link>
                        </div>
                      </div>
                    </li>

                  </ul>
                )}
              {(!localStorage.getItem("Islogin") ||
                localStorage.getItem("Islogin") === "false") && (
                  <ul className="d-flex mb-0 justify-content-end w-100 rightNavLogout mainuderlist">
                    {Mainprops.route.pathname !== "/" && (
                      <li className="list-inline-item">
                        {" "}
                        <Link to="/" aria-label="Home">
                          {" "}
                          <i
                            className="fa fa-home"
                            aria-hidden="true"
                            style={{
                              marginTop: "20%",
                              padding: "5px",
                              fontSize: "19px",
                            }}
                          ></i>
                          {/* <span class="sr-only">Home</span> */}
                        </Link>
                      </li>
                    )}

                    <li className="list-inline-item sToMain">
                      <a href="#main-content" class="fmRadioBtn ml-auto">{this.props.t('skip_main_content', { param: 'react' })}</a>
                    </li>


                    <li className="list-inline-item">
                      <Link to="/user-manual" aria-label="User Manuals">
                        {this.props.t("homeContent.userManual", {
                          param: "react",
                        })}
                      </Link>
                    </li>
                    <li className="list-inline-item">
                      <Link to="/screen-reader">{this.props.t('screen_reader', { param: 'react' })}</Link>
                    </li>
                  </ul>
                )}
            </div>


          </div>
        </div>



        <div id="testmodal" className="modal fade">
          <div className="modal-dialog" style={{ maxWidth: "969px" }}>
            <div className="modal-content d-block">

              <div className="modal-body pt-2  0 text-center">

                <div className="abt_mela">

                  <h4 className="pb-2 slogan">
                    Punjab Rozgar Department
                  </h4>
                  <div className="abt_mela">
                    <img
                      alt="logo"
                      src="images/logo-new2.png"
                      className="img-fluid pb-3 home-top-logo top_log_job_mela"
                      style={{ position: "absolute", left: "40%" }}
                    />
                    <img
                      alt="gif"
                      src="/images/ghrghr.gif"
                      className="img-fluid pb-2 jobmela_banner"
                    />


                    <div className="outerbtns">
                      <div className="flexbtns ml-4">
                        <a
                          aria-label="Register with portal"
                          className="mr-4" href="/signup">
                          <button
                            aria-label="Register with portal"
                            type="button"
                            className={
                              "btn btn-primart btn-primary2 print-btn mx-auto d-block mb-2 mt-2"
                            }
                          >
                            Register with portal
                          </button>
                        </a>
                        <a
                          aria-label="Login into portal"
                          className="ml-4" href="/signin">
                          <button
                            aria-label="Login into portal"
                            type="button"
                            className={
                              "btn btn-primart btn-primary2 print-btn mx-auto d-block mb-2 mt-2"
                            }
                          >
                            Login into portal
                          </button>
                        </a>
                      </div>
                    </div>
                    <ul className={"text-left fair-date pl-3"}>
                      <li>
                        <b style={{ fontWeight: "700" }}>
                          For assistance in participation, please contact the
                          District Bureau office of your district, details of
                          which are available
                        </b>
                        <a
                          aria-label="District Bureau office"
                          href="http://www.pgrkam.com/employment">here</a>
                      </li>

                    </ul>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>

        <nav className="navbar navbar-expand-md bg-dark2  mb-0 pb-35" aria-label="Primary navigation">
          <div className="container">
            <div className="row">
              <div class="d-flex justify-content-start">
                <div class="mt-1 emblemLogo">
                  <img src="/images/Punjab-emblem-logo.svg" alt="Advertisement" className="img-fluid adsclass emblenlogo" />
                </div>
                <Link to="/" className="navbar-brand p-0 m-0">
                  <img
                    alt="Punjab Rozgar Department"
                    src={"/images/logo-header.svg"}
                    className="img-fluid"
                  />
                </Link>
                <h2
                  className="nav-heading fontsmall"
                  style={{
                    fontSize: "18px",
                    textAlign: "left",
                    marginLeft: "6px",
                  }}
                >
                  {/* {this.props.t("banner.ggr", { param: "react" })} <br /> */}
                  {this.props.t("banner.subtitle_1", { param: "react" })}
                  <br />
                  <span style={{ lineHeight: "30px", fontSize: "inherit" }}>
                    {this.props.t("banner.subtitle_2", { param: "react" })}
                  </span>

                  {/* <span
                    className="n1 extrasmall-subtitle"
                    style={{ fontWeight: "600", lineHeight: "20px"
                  >
                    {this.props.t("banner.subtitle_1", { param: "react" })}
                  </span> */}
                  {/* <br />
                  <span
                    className="n1 extrasmall-subtitle"
                    style={{ fontWeight: "600", lineHeight: "20px" }}
                  >
                    {this.props.t("banner.subtitle_2", { param: "react" })}
                  </span>
                  <br /> */}

                </h2>
              </div>
            </div>
            <div className="row  m-0 outr-notify" id={"job-mela-tooltip"}
              data-placement="bottom">

            </div>

            {/* <button className="navbar-toggler mx-auto mb-2 collapsibleNavbarTwo" type="button" data-toggle="collapse" data-target="#collapsibleNavbarTwo" aria-label="Toggle navigation">
              <span className="fa fa-bars" aria-hidden="true"></span>
            </button> */}

            <button
              className="navbar-toggler mx-auto mb-2 collapsibleNavbarTwo"
              type="button"
              data-toggle="collapse"
              data-target="#collapsibleNavbarTwo"
              aria-controls="collapsibleNavbarTwo"
              aria-expanded="false"
              aria-label="Toggle navigation menu"
            >
              <span className="fa fa-bars" aria-hidden="true"></span>
              <span className="visually-hidden">Menu</span>
            </button>


            <div className="collapse navbar-collapse me-3" id="collapsibleNavbarTwo">
              <ul className="navbar-nav ms-auto mobile-noneclass">
                <li className="nav-item">
                  <Link className="nav-link"
                    to="/">{this.props.t('menu.home', { param: 'react' })}</Link>
                </li>
                {/* <li className="nav-item">
                  <a className="nav-link"
                    href="https://cms.pgrkam.com/about-employment-department"    > {this.props.t('menu.aboutUs', { param: 'react' })}</a>
                </li> */}
                <li className="nav-item">
                  <a
                    aria-label="About us"
                    className="nav-link"
                    href="/about"> {this.props.t('menu.aboutUs', { param: 'react' })}</a>
                </li>

                <li className="nav-item">

                  <Link className="nav-link" style={{ textTransform: "none" }}
                    to="/contact-us">{this.props.t('menu.contactUs', { param: 'react' })}</Link>
                </li>

              </ul>
            </div>
            {/* <div class="mt-1 emblemLogo">
              <img src="/images/Punjab-emblem-logo.svg" alt="Advertisement" className="img-fluid adsclass emblenlogo" />
            </div> */}
          </div>
        </nav>

        <div className="fraud-notify">
          <div
            className={`announcement-ticker ${this.state.isNotificationPaused ? 'paused' : ''}`}
            id="noticeMarquee"

          >
            <div

            >

              {this.props.actionReducer.headinglist && this.props.actionReducer.headinglist.map((heading, index) =>
              (
                <>
                  <a
                    className="ml-2" key={index + "head"}
                    target={`${heading.notification_open_in}`}
                    aria-label={heading.aria_label}
                    style={{
                      textDecoration: "none",
                      color: "#fff",
                      padding: "0 10px",
                    }} href={heading.notification_url}>
                    <b style={{ fontSize: "15px" }}>{heading.notification_message}</b>
                  </a> |
                </>
              )
              )}
            </div>

          </div>
          <div className="startStop">
            <button
              aria-label='Start notification'
              type="button"
              onClick={() => this.setState({ isNotificationPaused: false })}
              title="Start"
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                color: '#fff',
                fontSize: '16px',
                marginRight: '5px',
              }}
            >
              <i className="fa fa-play-circle" role="presentation"></i>
            </button>
            <button
              aria-label='Stop notification'
              type="button"
              onClick={() => this.setState({ isNotificationPaused: true })}
              title="Stop"
              style={{
                backgroundColor: 'transparent',
                border: 'none',
                color: '#fff',
                fontSize: '16px',
              }}
            >
              <i className="fa fa-pause-circle"></i>
            </button>
          </div>
        </div>

        <div className="mobile-blockclass">
          <nav class="navbar navbar-expand-lg navbar-light bgOrange" aria-label="Secondary navigation">
            <div className="container" >


              <button
                className="navbar-toggler ms-auto"
                type="button"
                data-toggle="collapse"
                data-target="#collapsibleNavbar"
                aria-label="Menu"
                role="button"
              >
                <span className="fa fa-bars"></span>
              </button>



              <div
                className="collapse navbar-collapse"
                id="collapsibleNavbar"
                style={{ flexGrow: "0" }}
                role="navigation"
                aria-label="Main navigation"
              >
                {this.props.actionReducer?.menudata ? (
                  <ul className="navbar-nav ml-auto mHeightScroll" role="menubar">
                    {/* <div>
                      <li className="nav-item">
                        <a className="nav-link" href="https://pgrkam.com/">{this.props.t('menu.home', { param: 'react' })}</a>
                      </li>
                      <li className="nav-item">
                        <a className="nav-link"
                          href="/about"    > {this.props.t('menu.aboutUs', { param: 'react' })}</a>
                      </li>

                      <li className="nav-item">

                        <a className="nav-link" href="https://pgrkam.com/contact-us">{this.props.t('menu.contactUs', { param: 'react' })}</a>
                      </li>
                    </div> */}

                    {this.props.actionReducer?.menudata?.map((menu) => (
                      <li
                        key={menu.id}
                        className={`nav-item ${menu.sub_links_count > 0 ? "dropdown" : ""}`}
                        onFocus={() => this.openDropdown(menu.id)}
                        onBlur={(e) => this.handleDropdownBlur(e, menu.id)}
                        role="none"
                      >
                        {menu.sub_links_count > 0 ? (
                          <>
                            <a
                              className="nav-link dropdown-toggle"
                              href="#"
                              id={`dropdown-${menu.id}`}
                              aria-haspopup="true"
                              aria-expanded="false"
                              aria-controls={`dropdown-menu-${menu.id}`}
                              role="menuitem"
                              data-bs-toggle="dropdown"
                            >
                              {menu.title}
                            </a>
                            <ul
                              className="dropdown-menu dropdown-menu-home"
                              id={`dropdown-menu-${menu.id}`}
                              role="menu"
                              aria-labelledby={`dropdown-${menu.id}`}
                            >
                              {menu.sub_links.map((subMenu) => (
                                <li key={subMenu.id} role="none">
                                  <a
                                    className="dropdown-item"
                                    href={subMenu.href}
                                    role="menuitem"
                                  >
                                    {subMenu.title}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </>
                        ) : (
                          <Link
                            className="nav-link"
                            to={menu.href || "#"}
                            role="menuitem"
                          >
                            {menu.title}
                          </Link>
                        )}
                      </li>
                    )
                    )}
                  </ul>
                ) : null}
              </div>


            </div>
          </nav>
        </div>

        {(!localStorage.getItem("Islogin") ||
          localStorage.getItem("Islogin") === "false") && (
            // <div className="icon-bar iconrelawe">
            //   {this.props.actionReducer.medialist && this.props.actionReducer.medialist.map((media, index) => {
            //     console.log(media, "mediamedia")
            //     return (
            //       <>
            //         <Link
            //           to={window.location.pathname}
            //           data-target="#exampleSocialModal"
            //           data-toggle="modal"
            //           className={`${media.platform_name} iconrela`}
            //           // target="_blank"
            //           onClick={() => {
            //             this.setState({ media_url: media.platform_url, platform_name: media.platform_name })
            //           }}
            //           aria-label={`${media.aria_label}`}
            //         >
            //           <i className={`fa ${media.icon_class}`} role="presentation" aria-hidden="true"></i>
            //           <div className="opnehovertik"></div>
            //         </Link>
            //         <div className="opnehovermedia">
            //           <div className="col-md-5 mb-4">
            //             <div className="social-card shadow-sm rounded p-3 bg-white">
            //               {console.log(this.state.platform_name, "platgforjfnkjdf")}
            //               {this.state.platform_name === "facebook" && (
            //                 <div
            //                   className="fb-page"
            //                   data-href="https://www.facebook.com/degsdt"
            //                   data-tabs="timeline"
            //                   data-width=""
            //                   data-height="500"
            //                   data-small-header="false"
            //                   data-adapt-container-width="true"
            //                   data-hide-cover="false"
            //                   data-show-facepile="true"
            //                 >
            //                   <blockquote
            //                     cite="https://www.facebook.com/degsdt"
            //                     className="fb-xfbml-parse-ignore"
            //                   >
            //                     <a
            //                       aria-label="Visit DEGSDT Facebook page"
            //                       href="https://www.facebook.com/degsdt">DEGSDT Facebook</a>
            //                   </blockquote>
            //                 </div>
            //               )}

            //               {this.state.platform_name === "youtube" && (
            //                 <iframe
            //                   width="100%"
            //                   height="500"
            //                   src={`https://www.youtube.com/embed?listType=user_uploads&list=${this.state.media_url.split('/@')[1]}`}
            //                   title="YouTube feed"
            //                   frameBorder="0"
            //                   allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            //                   allowFullScreen
            //                 ></iframe>
            //               )}

            //               {this.state.platform_name === "linkedin" && (
            //                 <iframe
            //                   src={`https://www.linkedin.com/embed/feed/update?url=${this.state.media_url}`}
            //                   height="500"
            //                   width="100%"
            //                   frameBorder="0"
            //                   allowFullScreen
            //                   title="LinkedIn Feed"
            //                 ></iframe>
            //               )}

            //               {this.state.platform_name === "instagram" && (
            //                 <iframe
            //                   src={`https://www.instagram.com/${this.state.media_url.split('.com/')[1]}embed`}
            //                   height="500"
            //                   width="100%"
            //                   frameBorder="0"
            //                   allowFullScreen
            //                   title="Instagram Feed"
            //                 ></iframe>
            //               )}

            //               {this.state.platform_name === "twitter" && (
            //                 <a
            //                   className="twitter-timeline"
            //                   data-width="500"
            //                   data-height="500"
            //                   href={this.state.media_url}
            //                 >
            //                   Tweets by DEGSDT
            //                 </a>
            //               )}
            //             </div>
            //           </div>

            //         </div>
            //       </>
            //     )
            //   }
            //   )}
            // </div>

            <div className="icon-bar iconrelawe">
              {this.props.actionReducer.medialist &&
                this.props.actionReducer.medialist.map((media, index) => {
                  const showHoverPopup = ["facebook", "youtube", "instagram"].includes(
                    media.platform_name
                  );
                  const iconId = `social-icon-${index}`;

                  return (
                    <a
                      key={index}
                      id={iconId}
                      className={`${media.platform_name}`}
                      tabIndex="0"
                      onMouseEnter={() => {
                        if (showHoverPopup)
                          this.setState({ hoveredPlatform: media.platform_name });
                      }}
                      onMouseLeave={() => this.setState({ hoveredPlatform: null })}
                      aria-label={media.aria_label}
                      role="button"
                      onClick={() => this.handleOpenModal(media, iconId)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          this.handleOpenModal(media, iconId);
                        }
                        // allow normal Tab behavior for focus navigation
                      }}
                    >
                      <span className="iconrela">
                        <i
                          className={`fa ${media.icon_class}`}
                          role="presentation"
                          aria-hidden="true"
                          style={{ cursor: "pointer" }}
                        ></i>
                      </span>

                      {showHoverPopup &&
                        this.state.hoveredPlatform === media.platform_name && (
                          <div className="opnehovermedia">
                            {this.renderSocialFeed()}
                          </div>
                        )}
                    </a>
                  );
                })}
            </div>

          )}

        <div
          className="modal fade"
          id="exampleSocialModal"
          role="dialog"
          aria-labelledby="exampleSocialModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header border-bottom-0">
                <h4
                  className="sr-only"
                  id="exampleSocialModalLabel"
                >
                  Punjab Rozgar Department
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this.handleCloseModal}
                ></button>
              </div>

              <div className="modal-body py-0">
                <p className="fSize18">
                  You are being redirected to an external website. Please note
                  that Punjab Rozgar Department Website cannot be held
                  responsible for external websites.
                </p>
              </div>

              <div className="modal-footer border-top-0">
                <button
                  aria-label="Proceed to external website"
                  type="button"
                  className="btn btn-success"
                  onClick={() => {
                    window.open(this.state.media_url, "_blank");
                    this.handleCloseModal();
                  }}
                  data-dismiss="modal"
                >
                  Proceed
                </button>
                <button
                  aria-label="Cancel and stay on current page"
                  type="button"
                  className="btn btn-danger"
                  data-dismiss="modal"
                  onClick={this.handleCloseModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

        <NotificationContainer />
      </section>
    );
  }
}

const mapStateToProps = (store) => {
  return store;
};
export default connect(mapStateToProps)(translate(Header));
